import { FuelIcon } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import ShieldLockIcon from 'components/ui/ShieldLockIcon';
import { DS_TOKENS } from 'constants/styled.contants';
import React from 'react';
import { getInitialsFromName } from 'utils/getNameInitials';
import * as Styled from './styled';

export const Avatar: React.FC<{
  name: string;
  picture: string;
  scrolledValue: number;
  isSmallProfile: boolean;
  isPaidFee: boolean;
}> = ({ name, picture, scrolledValue, isSmallProfile, isPaidFee }) => {
  const renderAvatarContent = () => (
    <Styled.AvatarWrapper scrolledValue={scrolledValue} isSmallProfile={isSmallProfile} data-testid="avatar-wrapper">
      <Styled.CustomAvatar isPaidFee={isPaidFee}>
        {!!picture && (
          <img
            src={picture}
            alt={getInitialsFromName(name)}
            data-testid={`${isSmallProfile ? 'mobile' : 'desk'}-trucker-selfie`}
          />
        )}
        {!picture && <FuelIcon size="huge" color="default" name="user-area" />}
      </Styled.CustomAvatar>
      {isPaidFee && (
        <Styled.PaidFeeBadge scrolledValue={scrolledValue}>
          <ShieldLockIcon height={32} />
        </Styled.PaidFeeBadge>
      )}
    </Styled.AvatarWrapper>
  );

  return (
    <>
      {isSmallProfile ? (
        <FuelFlex
          defaultProps={{
            height: '80px',
            alignItems: 'center',
            justifyContent: 'center',
            customMargin: `0 0 ${DS_TOKENS.spacing.km4} 0`,
          }}
        >
          {renderAvatarContent()}
        </FuelFlex>
      ) : (
        renderAvatarContent()
      )}
    </>
  );
};
